import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from './router'

import i18n from './i18n';
import { VueReCaptcha } from 'vue-recaptcha-v3'

const app = createApp(App)
app.use(VueSweetalert2)
app.use(router)
app.use(i18n)
app.use(VueReCaptcha, {
    // siteKey: '6LckvAEhAAAAAPlrd-aBxBGjOunXyBWiIuM8ZV-G',
    siteKey: '6LdsA8wsAAAAAA-Y9T1a-MaPb6FvvihZtZcXcdun',
    loaderOptions: {
        autoHideBadge: true
    }
})
app.mount('#app')